var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9870)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9870)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54588 18.012C7.24237 20.0873 9.39375 21.4167 12 22C14.6062 21.4167 16.758 20.0873 18.4553 18.012C20.1518 15.9373 21 13.6333 21 11.1V5L12 2L3 5V11.1C3 13.6333 3.84863 15.9373 5.54588 18.012ZM10.3688 15.5L10.7063 17H12.9563L13.2937 15.5C13.5187 15.4167 13.7299 15.3293 13.9271 15.238C14.1236 15.146 14.325 15.0333 14.5312 14.9L16.1625 15.35L17.2875 13.65L15.9938 12.65C16.0313 12.45 16.05 12.2417 16.05 12.025C16.05 11.8083 16.0313 11.6 15.9938 11.4L17.2875 10.4L16.1625 8.65L14.5312 9.15C14.325 9 14.1236 8.875 13.9271 8.775C13.7299 8.675 13.5187 8.58333 13.2937 8.5L12.9563 7H10.7063L10.3688 8.5C10.1438 8.58333 9.93263 8.67067 9.73538 8.762C9.53888 8.854 9.3375 8.96667 9.13125 9.1L7.5 8.65L6.375 10.35L7.66875 11.35C7.63125 11.5833 7.6125 11.8 7.6125 12C7.6125 12.2 7.63125 12.4167 7.66875 12.65L6.375 13.65L7.5 15.35L9.13125 14.9C9.3375 15.0333 9.53888 15.146 9.73538 15.238C9.93263 15.3293 10.1438 15.4167 10.3688 15.5ZM13.4209 13.413C12.9799 13.8043 12.45 14 11.8313 14C11.2125 14 10.683 13.8043 10.2428 13.413C9.80175 13.021 9.58125 12.55 9.58125 12C9.58125 11.45 9.80175 10.979 10.2428 10.587C10.683 10.1957 11.2125 10 11.8313 10C12.45 10 12.9799 10.1957 13.4209 10.587C13.8611 10.979 14.0813 11.45 14.0813 12C14.0813 12.55 13.8611 13.021 13.4209 13.413Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPermissions);
export default __webpack_public_path__ + "static/media/custom_permissions.2c6e813f538aa2146679cf13993a6a37.svg";
export { ForwardRef as ReactComponent };